import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import ReduxUtils from '../../utils/ReduxUtils';
import utils from './utils';
import actionTypes from './actionTypes';
/**
 * Action creators for the Profile module. An instance of {@link ProfileModel}
 * will be stored here.
 * @namespace ProfileActions
 */

var actions = function actions() {
  _classCallCheck(this, actions);
};

_defineProperty(actions, "getUserProfile", function (dispatch) {
  ReduxUtils.generateAction(dispatch, utils.fetchUserProfile, actionTypes);
});

_defineProperty(actions, "resetError", function (dispatch) {
  ReduxUtils.resetErrorAction(dispatch, actionTypes.failureAction);
});

export { actions as default };